import { appConfig } from '@/config/app.ts'

export interface MarketplaceOrdersState {
  filters: string
}

export const initialState: MarketplaceOrdersState = {
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
